module.exports = __webpack_public_path__ + "img/live-streaming-architecture.58077071.png";